import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {PesTask} from '@pes/ui';

@Component({
    selector: 'lbpa-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

    @Input() public task: PesTask = null;
    @Input() public healthData: boolean;

    @Output()
    public goToValidate: EventEmitter<any> = new EventEmitter<any>();

    public isIos: boolean = false;

    public qr: boolean = true;

    constructor(private readonly deviceService: DeviceDetectorService) {
    }

    public ngOnInit(): void {
        const deviseInfo = this.deviceService.getDeviceInfo();
        this.isIos = deviseInfo.os === 'iOS' || deviseInfo.device === 'iPad';
        this.qr = !this.deviceService.isMobile() && !this.deviceService.isTablet() && !('ontouchstart' in window || !!(navigator.msMaxTouchPoints));
    }

    protected submit(): void {
        this.goToValidate.emit();
    }

}



// WEBPACK FOOTER //
// ./src/app/component/step-parcours-lbpa/welcome/welcome.component.ts